import {
  getMySajuAPI,
  getMySajuDetailAPI,
  getMySajuGroupAPI,
  setMySajuAPI,
} from '@/api/calendarApi';
import { DEV_MODE } from '@/config/dev-mode';

/** '내 사주' 로딩 상태 */
const isMySajuLoading = ref(false);
/** '내 사주' 호출 성공 여부 */
const isMySajuLoaded = ref(false);

export const useMySajuAPI = ({ errorMessage }) => {
  /** 선택된 '내 사주' ID 조회 */
  const getMySajuId = async () => {
    try {
      const params = { serviceCategory: 'DAILY_FORTUNE_CALENDAR' };
      const result = await getMySajuAPI(params);
      if (result.content && result.content.length > 0) {
        return result.content[0]['guest_user_id'];
      } else {
        return null;
      }
    } catch (e) {
      if (DEV_MODE && errorMessage)
        errorMessage.value = {
          type: 'getMySajuId',
          error: e,
        };
      console.error('내 사주 ID 조회 실패', e);
      return null;
    }
  };

  /** '내 사주' 데이터 조회 */
  const getMySajuDetailById = async (guestUserId) => {
    try {
      const params = { serviceCategory: 'DAILY_FORTUNE_CALENDAR' };
      const result = await getMySajuDetailAPI({ guestUserId, params });
      return result;
    } catch (e) {
      if (DEV_MODE && errorMessage)
        errorMessage.value = {
          type: 'getMySajuDetailById',
          error: e,
        };
      console.error('내 사주 조회 실패:', e);
    }
  };

  /** '내 사주' 그룹 내 목록 불러오기 */
  const getMySajuList = async (params) => {
    try {
      const result = await getMySajuGroupAPI(params);
      return result;
    } catch (e) {
      if (DEV_MODE && errorMessage)
        errorMessage.value = {
          type: 'getMySajuList',
          error: e,
        };
      console.error('내 사주 불러오기 에러:', e);
      return null;
    }
  };

  /** '내 사주' 저장/설정 (대표 설정 등) */
  const setMainMySaju = async (params) => {
    try {
      const result = await setMySajuAPI(params);
      return result;
    } catch (e) {
      if (DEV_MODE && errorMessage)
        errorMessage.value = {
          type: 'setMainMySaju',
          error: e,
        };
      console.error('내 사주 설정 에러:', e);
    }
  };

  return {
    isMySajuLoading,
    isMySajuLoaded,
    getMySajuId,
    getMySajuDetailById,
    getMySajuList,
    setMainMySaju,
  };
};
